import { parseBooleanString } from "../../../util/utility";
import { CXoneAgentEvent } from '../agent/cxone-agent-event';


/**
 * Model class for Mute event
 */
export class MuteEvent extends CXoneAgentEvent {
    /**
     * @remarks - A boolean value which tells us if the agent is muted or not.
     */
    public agentMuted!: boolean;
    /**
     * The parse method will take the data object and assign the values to the MuteEvent class properties
     * @param data - Data object received
     * @example - 
     * ```
     * parse(data);
     * ```
     */
    public parse(data: { [key: string]: string }): void {
        this.iisHost = data.IISHost;
        this.vcHost = data.VCHost;
        this.agentMuted = parseBooleanString(data.AgentMuted);
    }

}